/**
 * @generated SignedSource<<e721a10ea2fcc0d4b62689f1b679ea8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetNoteFontSize = "LARGE" | "MEDIUM" | "SMALL";
export type WidgetNoteFontStyle = "BOLD" | "CURSIVE" | "DEFAULT";
import { FragmentRefs } from "relay-runtime";
export type useNoteWidgetStyleText_widgetNotePage$data = {
  readonly backgroundColor: string | null;
  readonly fontColor: string | null;
  readonly fontSize: WidgetNoteFontSize;
  readonly fontStyle: WidgetNoteFontStyle;
  readonly image: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "useNoteWidgetStyleText_widgetNotePage";
};
export type useNoteWidgetStyleText_widgetNotePage$key = {
  readonly " $data"?: useNoteWidgetStyleText_widgetNotePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNoteWidgetStyleText_widgetNotePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useNoteWidgetStyleText_widgetNotePage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontStyle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "c4fb3d85c34c85897a78a8ab79b4255f";

export default node;
